import React, {MouseEvent, useEffect} from 'react';
import {GetNotificationsV2Response} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/notification_center/v1/service.types';
import {
  COLORS,
  DiscountBanner as DiscountBannerBase,
} from '@aboutyou/ui-components';
import {Notification} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/notification_center/v1/notifications.types';
import {useTrackPromotion} from '@aboutyou/tracking';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {isExternalLink, useHistory} from '@aboutyou/router';

export interface NotificationBannerViewProps {
  reducedSize?: boolean;
  onClick?: VoidFunction;
  hideSimpleCampaign?: boolean;
}

const getNotificationItem = (notificationItem: Notification['item']) => {
  switch (notificationItem?.$case) {
    case 'almostSoldOut':
      return notificationItem.almostSoldOut;
    case 'desiredProduct':
      return notificationItem.desiredProduct;
    case 'generic':
      return notificationItem.generic;
    case 'orderUpdate':
      return notificationItem.orderUpdate;
    case 'priceDrop':
      return notificationItem.priceDrop;
    case 'returnUpdate':
      return notificationItem.returnUpdate;
    case 'saleEvent':
      return notificationItem.saleEvent;
    case 'sponsored':
      return notificationItem.sponsored;
  }
};

export const NotificationBannerView = ({
  notifications,
  reducedSize,
  onClick,
}: GetNotificationsV2Response & NotificationBannerViewProps) => {
  const history = useHistory();
  if (!notifications.length) {
    return null;
  }

  const heroNotification = notifications[0];
  // we know notification will exist as we are checking for it
  const heroNotificationItem = getNotificationItem(heroNotification!.item);

  if (!heroNotificationItem || !('heroInfo' in heroNotificationItem!)) {
    return null;
  }

  const onInfoClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const infoLink = heroNotificationItem.heroInfo?.infoConditions?.url;

    if (infoLink && isExternalLink(infoLink)) {
      window.open(infoLink, '_blank');
    } else if (infoLink) {
      history.push(infoLink);
    }
  };

  return (
    <>
      <TrackBannerPromotion url={heroNotificationItem?.url?.url || ''} />
      <DiscountBannerBase
        reducedSize={reducedSize}
        asSimpleBanner
        title={heroNotificationItem?.title || ''}
        link={heroNotificationItem?.url?.url}
        backgroundColor={heroNotificationItem.heroInfo?.color || COLORS.Black}
        onClick={onClick}
        onInfoClick={onInfoClick}
      />
    </>
  );
};

const TrackBannerPromotion: React.FC<{url: string}> = ({url}) => {
  const trackPromotion = useTrackPromotion();

  useEffect(() => {
    const id = url.split('?')[0]?.split('-').pop();

    trackPromotion({
      promotion: {
        campaign: {
          id: Number(id),
          name: 'banner',
          destinationId: id,
          path: url,
        },
        source: TrackingPromotionCreative.Banner,
      },
      streamPosition: 0,
      actionType: 'impression',
    });
  }, [url]);

  return null;
};
